import React from 'react';
import '../../index.css';

function FormItem({
  name,
  placeholder,
  type = "text",
  value,
  onChange,
  inputName,
  error,
  ...props
}) {
  return (
    <div className='flex flex-col gap-1'>
      <label className='text-dark-1 font-normal text-[16px]'>
        {name} *
      </label>
      <input
        type={type}
        className={`p-2 md:p-3 border ${error ? 'border-red-500' : 'border-zinc-200'} 
        focus:ring-0 focus:outline-none rounded-md w-full text-xs md:text-sms`}
        name={inputName || name.toLowerCase().replace(/\s+/g, '_')}
        placeholder={placeholder}
        required
        value={value}
        onChange={onChange}
        {...props}
      />
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
}

export default FormItem;